import { store } from "../app/store.js";
import { setAIGeneratedErrorReporter } from "./aiGenerated.js";
import { dispatchAIGeneratedChipFailure } from "./aiGeneratedSentry.js";
import { LaunchError } from "./errors.js";

let installed = false;

export const installAIGeneratedErrorReporter = () => {
  if (installed) return;
  installed = true;
  setAIGeneratedErrorReporter(({ functionName, context }) => {
    dispatchAIGeneratedChipFailure({
      dispatch: store.dispatch,
      launchError: LaunchError,
      functionName,
      context,
    });
  });
};
